import { RouteObject } from "react-router-dom";
import KanbanOverview from "../pages/admin/kanban/KanbanOverview";

export const kanbanRoutes: RouteObject[] = [
  {
    id: "kanban-overview",
    index: true,
    element: <KanbanOverview />,
  },
];
